module.exports = __webpack_public_path__ + "img/phoneScreens.de1deac6.png";